module.exports = __webpack_public_path__ + "img/back-box.cfc356c4.svg";